import {action, makeAutoObservable, runInAction} from "mobx";

export default class ThingsStore {
    constructor() {
        this._data = [
            {
                id: '123',
                key: '123',
                name: '123',
                model: '123',
                serialNumber: '123',
                isOnline: true,
                equipment: {
                    description: "-",
                    facility: "-",
                    manufacturer: "-",
                    model: "-",
                    sn: "-",
                    type: "-",
                    city: "-",
                    address: "-",
                },
                settings: {
                    current_factor: 1.0,
                    voltage_factor: 1.0,
                }
            }
        ]
        this._id = '-'
        this._key = '-'
        this._name = '-'
        this._isDeviceOnline = false
        this._serialNumber = '-'
        this._model = '-'
        this._equipment = {
            description: "-",
            facility: "-",
            manufacturer: "-",
            model: "-",
            sn: "-",
            type: "-",
            city: "-",
            address: "-",
        }
        this._settings = {
            current_factor: 1.0,
            voltage_factor: 1.0,
        }
        this._gate = {
            id: '_',
            key: '_',
        }
        makeAutoObservable(this, {
            setIsOnline: action,
            setThingId: action,
            setName: action
        })
    }

    setData(newData) {
        this._data = newData
    }

    setIsOnline(index, bool) {
        this._data[index].isOnline = bool
    }

    setThingId(newID) {
        this._id = newID
    }

    setThingKey(newKey) {
        this._key = newKey
    }

    setName(newName) {
        this._name = newName
    }

    setIsDeviceOnline(bool) {
        this._isDeviceOnline = bool
    }

    setSerialNumber(newSerialNumber) {
        this._serialNumber = newSerialNumber
    }

    setModel(newModel) {
        this._model = newModel
    }

    setEquipment(action, newData) {
        switch (action) {
            case 'description':
                this._equipment.description = newData
                break
            case 'facility':
                this._equipment.facility = newData
                break
            case 'manufacturer':
                this._equipment.manufacturer = newData
                break
            case 'model':
                this._equipment.model = newData
                break
            case 'sn':
                this._equipment.sn = newData
                break
            case 'type':
                this._equipment.type = newData
                break
            case 'address':
                this._equipment.address = newData
                break
            case 'city':
                this._equipment.city = newData
                break
            default:
                break
        }
    }

    setSettings(action, newSettings) {
        switch (action) {
            case 'voltage':
                this._settings.voltage_factor = newSettings
                break
            case 'current':
                this._settings.current_factor = newSettings
                break
            default:
                break
        }
    }

    setGate(action, newItem) {
        switch (action) {
            case 'id':
                this._gate.id = newItem
                break
            case 'key':
                this._gate.key = newItem
                break
            default:
                break
        }
    }

    get data() {
        return this._data
    }

    get id() {
        return this._id
    }

    get key() {
        return this._key
    }

    get name() {
        return this._name
    }

    get isDeviceOnline() {
        return this._isDeviceOnline
    }

    get serialNumber() {
        return this._serialNumber
    }

    get model() {
        return this._model
    }

    get equipment() {
        return this._equipment
    }

    get settings() {
        return this._settings
    }

    get gate() {
        return this._gate
    }
}